import { render, staticRenderFns } from "./process-attention-vehicle-modal.vue?vue&type=template&id=3621e99a"
import script from "./process-attention-vehicle-modal.vue?vue&type=script&lang=js"
export * from "./process-attention-vehicle-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports